/* ko-cart-animation.js */
(function () {
  "use strict";

  document.addEventListener('DOMContentLoaded', function () {
    // Listen globally for any clicks on product form submissions
    document.body.addEventListener('click', function (e) {
      const target = e.target;
      
      // Intercept clicks on either your main buy buttons or your mobile sticky button
      if (target.classList.contains('product-form__submit') || target.id === 'ko-sticky-atc-btn') {
        
        // Find the primary product image to clone
        let sourceImg = document.querySelector('product-info .product__media img');
        if (target.id === 'ko-sticky-atc-btn') {
          sourceImg = document.querySelector('.ko-sticky-atc__thumbnail') || sourceImg;
        }

        if (!sourceImg) return;

        // Locate standard Dawn cart icons in the header
        const cartIcon = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
        if (!cartIcon) return;

        // Calculate positions relative to viewport
        const imgRect = sourceImg.getBoundingClientRect();
        const cartRect = cartIcon.getBoundingClientRect();

        // Create the flying duplicate element
        const flyingImg = document.createElement('img');
        flyingImg.src = sourceImg.src;
        flyingImg.className = 'ko-flying-img';
        
        // Match starting dimensions and position
        flyingImg.style.top = imgRect.top + 'px';
        flyingImg.style.left = imgRect.left + 'px';
        flyingImg.style.width = imgRect.width + 'px';
        flyingImg.style.height = imgRect.height + 'px';

        document.body.appendChild(flyingImg);

        // Execute transition in next animation frame
        requestAnimationFrame(function () {
          flyingImg.style.top = (cartRect.top + (cartRect.height / 2) - 10) + 'px';
          flyingImg.style.left = (cartRect.left + (cartRect.width / 2) - 10) + 'px';
          flyingImg.style.width = '20px';
          flyingImg.style.height = '20px';
          flyingImg.style.opacity = '0';
          flyingImg.style.transform = 'rotate(360deg) scale(0.1)';
        });

        // Clean up from the DOM and trigger the cart pulse
        setTimeout(function () {
          flyingImg.remove();
          
          // Trigger physical bounce feedback on header cart icon
          cartIcon.classList.add('ko-cart-pulse');
          setTimeout(function () {
            cartIcon.classList.remove('ko-cart-pulse');
          }, 400);

        }, 800);
      }
    });
  });
})();